// components/gallery/GalleryHeader.jsx
import { ArrowLeft, Share2, UploadCloudIcon } from "lucide-react";
import { useNavigate } from "react-router-dom";
import DynamicModal from "../Generic/DynamicModal";
import { useState } from "react";

const GalleryHeader = ({ eventName, photoCount, onUploadClick , onShare}) => {
  const navigate = useNavigate();
 
  return (
    <div className="flex items-center justify-between mb-8">
      <div className="flex items-center space-x-4">
        <button
          onClick={() => navigate(-1)}
          className="p-2 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-full transition-colors"
        >
          <ArrowLeft className="h-6 w-6" />
        </button>
        <div>
          <h1 className="text-3xl font-bold text-gray-900">{eventName}</h1>
          <p className="text-gray-600">{photoCount} photos</p>
        </div>
      </div>

      <div className="flex items-center space-x-3">
        <button onClick={onShare} className="inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors">
          <Share2 className="h-4 w-4 mr-2" />
          Share
        </button>
        <button
          onClick={onUploadClick}
          className="inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
        >
          <UploadCloudIcon className="h-4 w-4 mr-2" />
          Upload
        </button>
     
      </div>
    </div>
  );
};

export default GalleryHeader;
